export default __webpack_public_path__ + "static/media/1879.6679cbf8.png";